<template>
  <HighlightsWidget
    v-bind="policies"
    :flexLayout="true"
    :showLinkToFullList="true"
    title="Policies"
    v-on="$listeners"
  >
    <template v-slot:mainContent>
      <HighlightsStyledList
        :resources="policies.resources"
      />
    </template>
    <template v-slot:zeroState>
      <ZeroState
        icon="/adminportal/policies.svg"
        linkText="add a policy"
        message="Connect this device to a policy."
        v-on="$listeners"
      />
    </template>
  </HighlightsWidget>
</template>

<script>
import { S3BucketAddress } from 'client/util/Constants/ApplicationConstants';
import HighlightsStyledList from 'client/components/Highlights/HighlightsStyledList.vue';
import HighlightsWidget from 'client/components/Highlights/HighlightsWidget.vue';
import ZeroState from 'client/components/Highlights/ZeroState';

export default {
  name: 'DevicePoliciesWidget',

  components: {
    HighlightsWidget,
    HighlightsStyledList,
    ZeroState,
  },

  props: {
    policies: {
      type: Object,
      default: () => {},
    },
  },

  data: () => ({
    S3BucketAddress,
  }),
};
</script>
